export default {
  LoadingShimmer__ARIA_LABEL_LOADING: "Loading",
};
